<div class="bg-white rounded mb-3">
  <div class="border-bottom border-2">
    <div class="px-4">
      <h3 class="pt-2">{{ editMode ? "Edit Admin Role" : "Create Admin" }}</h3>
    </div>
  </div>
  <div class="p-4">
    <form *ngIf="createAdminForm" [formGroup]="createAdminForm" (submit)="onSubmit()">
      <div class="row mb-3">
        <div class="col-md-6">
          <label>First Name <span class="text-danger">*</span></label>
          <input class="form-control" type="text" placeholder="Enter Your First Name here" formControlName="first_name">
          <div class="alert alert-danger" *ngIf="formValidator.formErrors.first_name">
            {{ formValidator.formErrors.first_name }}
          </div>
        </div>
        <div class="col-md-6">
          <label>Last Name <span class="text-danger">*</span></label>
          <input class="form-control" type="text" placeholder="Enter Your Last Name here" formControlName="last_name">
          <div class="alert alert-danger" *ngIf="formValidator.formErrors.last_name">
            {{ formValidator.formErrors.last_name }}
          </div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-6">
          <label>Email <span class="text-danger">*</span></label>
          <input class="form-control" type="email" placeholder="Enter Your Email here" formControlName="email">
          <div class="alert alert-danger" *ngIf="formValidator.formErrors.email">
            {{ formValidator.formErrors.email }}
          </div>
        </div>
        <div class="col-md-6">
          <label>Phone <span class="text-danger">*</span></label>
          <input class="form-control" type="tel" placeholder="Enter Your Phone here" formControlName="phone">
          <div class="alert alert-danger" *ngIf="formValidator.formErrors.phone">
            {{ formValidator.formErrors.phone }}
          </div>
        </div>
        <div class="col-md-6">
          <label>Password <span class="text-danger">*</span></label>
          <input class="form-control" type="password" placeholder="Enter Your Password here" formControlName="password">
          <div class="alert alert-danger" *ngIf="formValidator.formErrors.password">
            {{ formValidator.formErrors.password }}
          </div>
        </div>
      </div>
      <div class="row mb-3">
      <div class="col-md-6 ">
        <label>Admin Role <span class="text-danger">*</span></label>
        <select formControlName="RoleId" (ngModelChange)="onRoleChange($event)" class="form-control">
          <option disabled value="null" selected>Choose admins roles</option>
          <option *ngFor="let role of roles" [value]="role.id">{{ role.name }}</option>
        </select>
        <div class="alert alert-danger" *ngIf="formValidator.formErrors.RoleId">
          {{ formValidator.formErrors.RoleId }}
        </div>
      </div>
      <div class="col-md-6 ">
        <label> MerchantId </label>
        <select formControlName="merchantId"  class="form-control">
          <option disabled value="null" selected>Assign Merchant</option>
          <option *ngFor="let merchant of merchants" [value]="merchant.id">{{ merchant.name }}</option>
        </select>
        <div class="alert alert-danger" *ngIf="formValidator.formErrors.merchantId">
          {{ formValidator.formErrors.merchantId }}
        </div>
      </div>
    </div>
      <ul class="list-group">
        <li class="list-group-item" *ngFor="let permission of rolePermissions">
          {{ permission.name }}
        </li>
      </ul>
      <div class="d-flex justify-content-end">
        <button class="btn btn-primary col-auto" type="submit" [disabled]="createAdminForm.invalid">
          Submit
        </button>
      </div>
    </form>
  </div>
</div>
<recaptcha
[size]="'invisible'"
[hide]="false"
>
</recaptcha>

